<template>
  <svg
    v-if="header"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 517.83 631.15"
    preserveAspectRatio="xMinYMax slice"
  >
    <path
      d="M 372.67 337.75 L 219.09 531.26 L 207.99 545.25 C 207.89 545.37 207.83 545.52 207.82 545.68 L 205.34 573.91 C 205.25 574.94 204.98 575.92 204.57 576.8 C 204.52 576.9 204.5 577.01 204.5 577.13 L 204.5 631.43 C 204.5 631.87 204.14 632.23 203.7 632.23 L 133.1 632.23 C 132.66 632.23 132.3 631.87 132.3 631.43 L 132.3 569.6 C 132.3 569.3 132.13 569.02 131.86 568.89 L 106.5 556.19 L 6.74 506.21 C 2.5 504.09 0.78 498.92 2.91 494.68 C 7.72 487.2 12.69 478.64 17.45 468.98 C 21.61 460.54 25 452.49 27.78 445.04 C 28.04 444.53 29.45 441.83 32.75 440.73 C 34.84 440.04 37.19 440.14 39.31 441.2 L 138.54 490.9 C 139.04 491.15 139.64 490.82 139.69 490.26 L 163.58 218.04 C 163.99 213.31 168.16 209.81 172.89 210.23 C 180.93 211.66 189.67 212.89 199.04 213.75 C 209.48 214.71 219.24 215.09 228.2 215.08 C 228.77 215.13 231.8 215.45 234.03 218.11 C 235.44 219.8 236.21 222.02 236.01 224.39 L 219.61 411.28 C 219.54 412.07 220.54 412.47 221.03 411.85 L 315.71 292.55 C 318.66 288.84 324.07 288.21 327.79 291.16 L 371.28 325.68 C 374.99 328.63 375.62 334.04 372.67 337.75 Z"
      :fill="color"
      :opacity="opacity"
    />

    <path
      d="M 138.8 30.88 C 148.44 114.3 283.75 169.88 408.41 224.89 C 443.75 242.84 460.64 280.35 457.55 302.47 C 450.25 354.69 366.53 539.07 323.14 613.17 C 309.46 636.53 406.81 627.37 406.81 627.37 L 517.83 375.351 L 517.83 240.921 L 402.08 -2.86 L 320.06 -0.84 C 318.92 0.57 385.66 132.64 379.98 132.4 C 361.27 125.12 240.94 79.79 216.78 33.1 C 182.42 -33.3 138.79 30.89 138.79 30.89 L 138.8 30.88 Z"
      :fill="color"
      :opacity="opacity"
    />
  </svg>

  <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420.75 300.21" preserveAspectRatio="xMinYMin slice">
    <path d="M288.17,227.27c-.12.06-.23.12-.35.18l.05-.1.3-.08Z" :fill="color" :opacity="opacity" />
    <path
      d="M 360.696 59.19 C 357.397 62.49 297.308 185.412 297.308 185.412 L 363.607 167.899 C 376.584 165.1 375.33 182.1 378.619 191.355 C 380.496 201.122 390.497 216.788 377.564 220.766 C 365.462 226.021 254.22 248.11 248.631 259.888 C 241.097 269.209 235.344 300.21 235.344 300.21 L 182.83 300.21 C 182.83 300.21 190.698 280.721 193.576 270.343 L 203.121 239.321 C 207.231 220.888 215.076 199.244 198.586 183.844 C 94.688 112.278 2.345 79.927 0 -1.128 L 58.175 0 C 58.175 0 61.734 38.857 147.509 85.512 C 155.009 89.589 161.832 93.367 168.043 96.846 L 135.14 0 L 189.596 0 L 248.465 158.833 C 248.465 158.833 293.953 67.301 322.308 19.946 C 323.43 18.068 323.119 15.668 321.563 14.123 C 313.731 6.345 304.353 0 304.353 0 L 420.75 0 L 420.75 17.416 L 410.585 21.213 C 403.541 23.657 408.963 30.623 408.963 30.623 L 420.75 45.382 L 420.75 137.302 C 420.75 137.302 376.708 74.145 371.018 65.745 C 366.963 59.756 363.997 55.89 360.696 59.19 Z"
      :fill="color"
      :opacity="opacity"
    />
  </svg>
</template>

<script>
export default {
  name: 'BranchShape',
  props: {
    header: Boolean,
    color: {
      type: String,
      default: '#E7E7D1'
    },
    opacity: {
      type: [String, Number],
      default: 1
    }
  }
}
</script>
